import { React, useState, useEffect, useRef } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import api from '../../config/axios';
import Swal from 'sweetalert2';

import { DayPicker } from "react-day-picker";
import { pt } from "react-day-picker/locale";
import "react-day-picker/dist/style.css";

import moment from "moment";

import '../../assets/styles/agendamento.css';
import { FaPlus, FaAngleLeft, FaAngleRight, FaFilter } from "react-icons/fa";

import AgendamentoModal from './modals/Agendamento';

moment.locale("pt-br");
const localizer = momentLocalizer(moment);

const Agendamentos = () => {
  const [error, setError] = useState(null);
  const [selectedDay, setSelectedDay] = useState(new Date());
  const [selectedColumns, setSelectedColumns] = useState(4);

  const [agendamentos, setAgendamentos] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [filtroNomeColaborador, setFiltroNomeColaborador] = useState('');

  const [selectedAgendamento, setSelectedAgendamento] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [horariosUnidade, setHorariosUnidade] = useState({ minTime: new Date().setHours(0, 0, 0, 0), maxTime: new Date().setHours(23, 59, 0, 0) });

  const fetchHorariosUnidade = async (data) => {
    try {
      const diaSemana = data.getDay(); 
      const response = await api.get(`/configuracao-agenda-unidade/dia/${diaSemana}`);
      if (response.data.data.disponivel) {
        const [horaInicio, minInicio] = response.data.data.hora_inicio.split(':').map(Number);
        const [horaTermino, minTermino] = response.data.data.hora_termino.split(':').map(Number);
        
        const minTime = new Date().setHours(horaInicio, minInicio, 0, 0);
        const maxTime = new Date().setHours(horaTermino, minTermino, 0, 0);
        
        setHorariosUnidade({ minTime, maxTime });
      } else {
        setHorariosUnidade({ 
          minTime: new Date().setHours(0, 0, 0, 0), 
          maxTime: new Date().setHours(23, 59, 0, 0) 
        });
      }
    } catch (err) {
      setHorariosUnidade({ 
        minTime: new Date().setHours(0, 0, 0, 0), 
        maxTime: new Date().setHours(23, 59, 0, 0) 
      });
    }
  };

  const fetchAgendamentos = async () => {
    Swal.fire({
      title: "Carregando...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    
    const data = selectedDay.toLocaleDateString();
    const [dia, mes, ano] = data.split("/");
    try {
      const response = await api.get(`/agendamentos?page=${currentPage}&limit=${selectedColumns}&nome_colaborador=${filtroNomeColaborador}&data=${ano}-${mes}-${dia}`);

      setColaboradores(response.data.records.map(obj => ({
        ...obj,
        resourceId: obj.id
      })) || []);

      setTotalPages((Math.ceil(response.data.totalRegistros / selectedColumns)) || 1);
      setError(null);
    } catch (err) {
      setError('Erro ao carregar a lista de agendamentos.');
    } finally {
      Swal.close();
    }
  };

  useEffect(() => {
    fetchAgendamentos(currentPage);
  }, [currentPage]);

  useEffect(() => {
    fetchHorariosUnidade(selectedDay);
  }, []);

  const lastSelectedDay = useRef(selectedDay);
  const lastSelectedColumns = useRef(selectedColumns);

  useEffect(() => {
    if (selectedDay) {
      if (
        lastSelectedDay.current.toLocaleDateString() !== selectedDay.toLocaleDateString() ||
        JSON.stringify(lastSelectedColumns.current) !== JSON.stringify(selectedColumns)
      ) {
        lastSelectedDay.current = selectedDay;
        lastSelectedColumns.current = selectedColumns;
        setCurrentPage(1);
        fetchAgendamentos();
        fetchHorariosUnidade(selectedDay);
      }
    }
  }, [selectedDay, selectedColumns]);

  useEffect(() => {
    const data = selectedDay.toLocaleDateString();
    const [dia, mes, ano] = data.split("/");
    const eventos = [];
    for (let i = 0; i < colaboradores.length; i++) {
      for (let j = 0; j < colaboradores[i].agendamentos.length; j++) {
        const colaborador_agendamento = colaboradores[i].agendamentos[j];

        for (let k = 0; k < colaborador_agendamento.servicos.length; k++) {
          const servico = colaborador_agendamento.servicos[k];
          
          if (!servico.hora_inicio || !servico.hora_termino) {
            continue;
          }
          
          const tempo_inicial = servico.hora_inicio.split(':');
          const tempo_final = servico.hora_termino.split(':');
          const cor = obterCorAgendamento(colaborador_agendamento.status);
          const evento = {
            id: `${colaborador_agendamento.id_agendamento}-${k}`, 
            agendamento_id: colaborador_agendamento.id_agendamento,
            title: colaborador_agendamento.cliente.nome + ' - ' + servico.servico.nome,
            start: new Date(ano, mes - 1, dia, tempo_inicial[0], tempo_inicial[1]),
            end: new Date(ano, mes - 1, dia, tempo_final[0], tempo_final[1]),
            resourceId: servico.id_pessoa_colaborador,
            style: cor,
            status: colaborador_agendamento.status,
            tempo: servico.servico.tempo,
            preco: servico.servico.preco,
            colaborador_nome: colaboradores[i].nome,
            observacao: colaborador_agendamento.observacao,
            data: moment(colaborador_agendamento.data).format('DD/MM/YYYY'),
            id_comanda: colaborador_agendamento.id_comanda,
            cliente: {
              label: colaborador_agendamento.cliente.nome,
              value: colaborador_agendamento.cliente.id,
              celular: colaborador_agendamento.cliente.celular
            },
            servico: {
              label: servico.servico.nome,
              value: servico.servico.id_servico
            },
            criado_por: colaborador_agendamento.criado_por,
            criado_em: colaborador_agendamento.criado_em,
            alterado_por: colaborador_agendamento.alterado_por,
            alterado_em: colaborador_agendamento.alterado_em
          }
          eventos.push(evento);
        }
      }
    }
    setAgendamentos(eventos);
  }, [colaboradores]);

  useEffect(() => {
    if (agendamentos.length > 0) {
      const eventElements = document.querySelectorAll(".rbc-event");
      eventElements.forEach((el) => {
        const innerDiv = el.querySelector('div[data-id]');

        const eventId = innerDiv?.getAttribute('data-id');
        const event = agendamentos.find((e) => e.id === eventId);
        
        if (event) {
          const tooltipContent = renderTooltipContent(event);

          el.setAttribute("data-bs-toggle", "tooltip");
          el.setAttribute("data-bs-html", "true");
          el.setAttribute("data-bs-title", tooltipContent);
        }
      });

      const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        new window.bootstrap.Tooltip(tooltipTriggerEl);
      });
    }
  }, [agendamentos]);

  const renderTooltipContent = (event) => {
    const dataFormatada = event.data ? moment(event.data, 'DD/MM/YYYY').format('DD/MM/YYYY') : 'N/A';
    const clienteNome = event.cliente?.label || 'N/A';
    const clienteCelular = event.cliente?.celular || 'N/A';
    const colaboradorNome = event.colaborador_nome || 'N/A';
    const servicoNome = event.servico?.label || 'N/A';
    const status = event.status ? event.status.charAt(0).toUpperCase() + event.status.slice(1) : 'N/A';
    const observacao = event.observacao || '';
    
    return `
      <div style="text-align: left; max-width: 250px;">
        <strong>${dataFormatada}</strong><br/>
        <strong>${clienteNome}</strong><br/>
        <hr>
        <strong>Telefone: </strong><span>${clienteCelular}</span><br/>
        <strong>Profissional: </strong><span>${colaboradorNome}</span><br/>
        <strong>Serviço: </strong><span>${servicoNome}</span><br/>
        <strong>Status: </strong><span>${status}</span><br/>
        <strong>Obs: </strong><span>${observacao}</span>
      </div>
    `;
  };

  const handleFiltrar = () => {
    fetchAgendamentos(1);
  };

  const handleHoje = () => {
    setSelectedDay(new Date());
    setCurrentPage(1);
  };

  const handleAddAgendamento = () => {
    setSelectedAgendamento(null);
    setIsModalOpen(true);
  };

  const handleEventClick = (event) => {
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      const tooltip = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
      if (tooltip) tooltip.hide();
    });

    let agendamentoCompleto = null;
    let todosServicos = [];
    let agendamentoBase = null;

    for (let i = 0; i < colaboradores.length; i++) {
      const agendamentos = colaboradores[i].agendamentos.filter(ag => ag.id_agendamento === event.agendamento_id);
      
      for (const agendamento of agendamentos) {
        if (!agendamentoBase) {
          agendamentoBase = agendamento;
        }
        
        for (const servico of agendamento.servicos) {
          if (!todosServicos.find(s => s.id === servico.id)) {
            todosServicos.push({
              id: servico.id,
              servico: {
                label: servico.servico.nome,
                value: servico.servico.id_servico
              },
              profissional: {
                label: colaboradores.find(c => c.id === servico.id_pessoa_colaborador)?.nome || 'Colaborador não encontrado',
                value: servico.id_pessoa_colaborador
              },
              tempo: servico.servico.tempo ? servico.servico.tempo.substring(0, 5) : '00:00',
              inicio: servico.hora_inicio ? servico.hora_inicio.substring(0, 5) : '00:00',
              fim: servico.hora_termino ? servico.hora_termino.substring(0, 5) : '00:00',
              valor: servico.preco_servico || servico.servico.preco,
              editar: false,
              assistentes: (servico.colaboradores || [])
                .filter(colab => colab.tipo_colaborador === 'assistente')
                .map(colab => ({
                  id: colab.id,
                  profissional: {
                    label: colab.colaborador?.nome || 'Colaborador',
                    value: colab.id_pessoa_colaborador
                  }
                }))
            });
          }
        }
      }
    }

    if (agendamentoBase && todosServicos.length > 0) {
      agendamentoCompleto = {
        ...agendamentoBase,
        servicos: todosServicos,
        cliente: {
          label: agendamentoBase.cliente.nome,
          value: agendamentoBase.cliente.id
        },
        data: moment(agendamentoBase.data).format('DD/MM/YYYY')
      };
    }

    setSelectedAgendamento(agendamentoCompleto);
    setIsModalOpen(true);
  };

  const paginationLeftAgendamento = () => {
    if (currentPage > 1) {
      setCurrentPage(prevPage => prevPage - 1);
    }
  };

  const paginationRightAgendamento = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prevPage => prevPage + 1);
    }
  };

  const obterCorAgendamento = (status) => {
    switch (status) {
      case "agendado": return { backgroundColor: "#078678B3", color: "black", border: "2px solid #036d61" }; // Verde Claro
      case "confirmado": return { backgroundColor: "#17a2b8B3", color: "black", border: "2px solid #17a2b8" }; // Azul Claro
      case "aguardando": return { backgroundColor: "#ffc107B3", color: "black", border: "2px solid #ffc107" }; // Amarelo
      case "em atendimento": return { backgroundColor: "#28a745B3", color: "black", border: "2px solid #28a745" }; // Verde
      case "pago": return { backgroundColor: "#ff8c69B3", color: "black", border: "2px solid #ff8c69" }; // Salmão
      case "finalizado": return { backgroundColor: "#0056b3B3", color: "white", border: "2px solid #0056b3" }; // Azul Escuro
      case "faltou": return { backgroundColor: "#6c757dB3", color: "white", border: "2px solid #6c757d" }; // Cinza
      case "cancelado": return { backgroundColor: "#bababa", color: "black", border: "2px solid #9b9b9b" }; // Cinza Claro
    }
  };

  const minTime = new Date(horariosUnidade.minTime);
  const maxTime = new Date(horariosUnidade.maxTime);

  const handleNavigate = () => { };

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="row mt-3">
            <div className="col-12">
              <h4 className="fw-bold">Agenda</h4>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                <div className="d-flex flex-wrap gap-2">
                  <button className="btn btn-outline-primary" onClick={handleAddAgendamento}>
                    <FaPlus /> Adicionar Agendamento
                  </button>
                  <button className="btn btn-outline-primary" onClick={handleHoje}>
                    Hoje
                  </button>
                </div>
                <div className="d-flex flex-wrap align-items-center gap-3">
                  <div className="d-flex align-items-center">
                    <label className="form-label fw-bold me-2 mb-0">Colunas</label>
                    <div className="btn-group" role="group">
                      {[4, 6, 8, 10].map((columns) => (
                        <button
                          key={columns}
                          type="button"
                          className={`btn btn-outline-primary ${selectedColumns === columns ? 'active' : ''}`}
                          onClick={() => setSelectedColumns(columns)}
                        >
                          {columns}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex">
                    <button className="btn btn-custom-secondary" disabled={currentPage === 1} onClick={paginationLeftAgendamento}>
                      <FaAngleLeft />
                    </button>
                    <button className="btn btn-custom-secondary ms-3" disabled={currentPage === totalPages} onClick={paginationRightAgendamento}>
                      <FaAngleRight />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-auto">
              <DayPicker
                mode="single"
                locale={pt}
                selected={selectedDay}
                onSelect={setSelectedDay}
              />
              <div className="mt-5">
                <input
                  type="text"
                  autoComplete="off"
                  value={filtroNomeColaborador}
                  placeholder="Nome do colaborador"
                  className="form-control"
                  onChange={(e) => setFiltroNomeColaborador(e.target.value.toUpperCase())}
                />
                <div className="mt-3 mb-5 d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-custom-primary"
                    onClick={handleFiltrar}
                  >
                    <FaFilter /> Filtrar
                  </button>
                </div>
              </div>
            </div>
            <div className="col">
              <div style={{ height: "70vh" }}>
                <Calendar
                  localizer={localizer}
                  date={selectedDay}
                  defaultView="day"
                  toolbar={false}

                  events={agendamentos}
                  resources={colaboradores}
                  resourceIdAccessor="resourceId"
                  resourceTitleAccessor="nome"
                  onNavigate={handleNavigate}

                  min={minTime}
                  max={maxTime}
                  step={15}
                  timeslots={1}
                  formats={{
                    timeGutterFormat: "HH:mm",
                  }}
                  culture="pt-BR"
                  eventPropGetter={(event) => ({
                    style: event.style,
                  })}

                  dayLayoutAlgorithm="no-overlap"
                  
                  onDoubleClickEvent={handleEventClick}
                  tooltipAccessor={() => null}

                  components={{
                    event: ({ event }) => (
                      <div data-id={event.id}>
                        {event.title}
                      </div>
                    ),
                    resourceHeader: ({ resource }) => (
                      <div style={{ display: "flex", alignItems: "center", padding: "5px", justifyContent: "center", minHeight: "50px" }}>
                        {resource.fotoum && (
                          <img
                            src={resource.fotoum}
                            alt={resource.nome}
                            style={{
                              borderRadius: "50%",
                              width: "40px",
                              height: "40px",
                              marginRight: "10px"
                            }}
                          />
                        )}
                        <span>{resource.nome}</span>
                      </div>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {isModalOpen && (
          <AgendamentoModal
            agendamento={selectedAgendamento}
            onClose={() => setIsModalOpen(false)}
            onAgendamentoAtualizado={() => fetchAgendamentos(currentPage)}
          />
        )}
      </div>
    </div>
  );
};

export default Agendamentos;
